export default {
    dependencies: ['$element', 'orgsubscriptionservice', 'careerPreferences'],
    callable(ele, orgSubscriptionService, careerPreferencesService) {
        const orgId = ele.getAttribute('data-org-id');
        const orgName = ele.getAttribute('data-org-name');
        const relation = ele.getAttribute('data-org-relation');
        const orgSubscribersEle = ele.querySelector('[data-org-subscribers]');
        const subscribeButtonEle = ele.querySelector('[data-org-subscribe]');
        const unsubscribeButtonEle = ele.querySelector(
            '[data-org-unsubscribe]'
        );

        if (subscribeButtonEle) {
            subscribeButtonEle.addEventListener('click', subscribe);
        }

        if (unsubscribeButtonEle) {
            unsubscribeButtonEle.addEventListener('click', unsubscribe);
        }

        function renderSubscribers(subscribers) {
            const text =
                subscribers === '0'
                    ? 'Bli den første til å følge firmaet!'
                    : `${subscribers} følger dette firmaet`;
            if (orgSubscribersEle.textContent) {
                orgSubscribersEle.textContent = text;
            } else {
                orgSubscribersEle.innerHTML = text;
            }
        }

        function toggle(data) {
            renderSubscribers(data.messages.subscribers);
            const isSubscribe = data.messages.action === 'subscribe';
            subscribeButtonEle.classList.toggle('hidden', isSubscribe);
            unsubscribeButtonEle.classList.toggle('hidden', !isSubscribe);
        }

        function subscribe() {
            orgSubscriptionService
                .subscribe(orgId, orgName, relation)
                .then(toggle);
            showPreferencePrompt();
        }

        function unsubscribe() {
            orgSubscriptionService.unsubscribe(orgId, relation).then(toggle);
        }

        function showPreferencePrompt() {
            const $container = ele.querySelector(
                '#react-app-career-preferences'
            );
            // the container is only available if toggles are active
            if ($container) {
                const orgName = ele.getAttribute('data-org-name');
                careerPreferencesService.renderPreferencePrompt(orgName);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/orgSubscribe.js